import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import { UploadApi } from '../../../../assets/js/lb-sdk/services/custom/Upload';
import { UPLOAD_TYPE, UPLOAD_STATUS } from '../../../enums';
import { CommissionUploadsFormComponent } from './commission-uploads-form/commission-uploads-form.component';
import { Event } from '../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-commission-uploads',
  templateUrl: './commission-uploads.component.html',
  styleUrls: ['./commission-uploads.component.css']
})
export class CommissionUploadsComponent extends BasicList {
  UPLOAD_STATUS: typeof UPLOAD_STATUS = UPLOAD_STATUS;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'name', placeholder: 'ID/Name', wildcard: true },
      { name: 'status', placeholder: 'File Status', options: UPLOAD_STATUS },
      { name: 'error', placeholder: 'Processing Status', optionsFunction: () => {
        return [
          { value: '--null--', description: 'PROCESSED' },
          { value: { neq: null }, description: 'HAS ERROR' }
        ]
      } }
    ],
    filters: {}
  };

  constructor(
    private commissionUploadApi: UploadApi,
    private modalService: BsModalService,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        type: UPLOAD_TYPE.COMMISSION_UPLOAD
      },
      include: 'user',
      order: 'uploadDate DESC'
    };
    this.settings = {
      createComponent: CommissionUploadsFormComponent,
      api: this.commissionUploadApi,
      ModalService: this.modalService
    };
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('File successfully uploaded for processing', 'Commission Upload');
      case 'initialized':
        this.getList();
      break;
    }
  }
}
